class StorageClass {
    constructor(type = 'local', consentCheckerFunction = Odigeo._.constant(true)) {
        this.type = type;
        this.storage = window[`${type}Storage`] || {};
        this.consentCheckerFunction = consentCheckerFunction;
    }

    get storage() {
        return this._storage;
    }

    set storage(storageObj) {
        const isValidStorage = ['getItem', 'setItem', 'removeItem'].every((f) => Odigeo._.isFunction(storageObj[f]));
        if (isValidStorage) {
            this._storage = storageObj; // Copy reference to the given object in window.
        } else {
            let closuredStorageObj = {};
            this._storage = StorageClass.getFallbackStorageObject(closuredStorageObj);
        }
    }

    get(key) {
        try {
            return this.consentCheckerFunction(key) ? this.storage.getItem(key): null;
        } catch (e) {
            return null;
        }
    }

    set(key, value) {
        try {
            if (this.consentCheckerFunction(key)) {
                this.storage.setItem(key, value);
                return true;
            }
        } catch (e) {
            if (['QUOTA_EXCEEDED_ERR', 'NS_ERROR_DOM_QUOTA_REACHED', 'QuotaExceededError'].includes(e.name)) {
                Odigeo.trigger('fullStorage');
            }
        }
        return false;
    }

    remove(key) {
        try {
            this.storage.removeItem(key);
            return true;
        } catch (e) {
            return false;
        }
    }

    clear() {
        try {
            this.storage.clear();
            return true;
        } catch (e) {
            return false;
        }
    }

    clearForced(keysForcedToBeCleared) {
        Odigeo._.each(keysForcedToBeCleared, (key) => {
            if (!Odigeo._.isNull(this.storage.getItem(key))) {
                this.storage.removeItem(key);
            }
        });
    }

    getAllKeys() {
        return Odigeo._.isFunction(this.storage.getAllKeys) ? this.storage.getAllKeys() : Odigeo._.keys(this.storage);
    }

    removeAllExcept(exceptionsList) {
        const keysToRemove = Odigeo._.difference(this.getAllKeys(), exceptionsList);
        Odigeo._.each(keysToRemove, (key) => this.storage.removeItem(key));
    }

    static getFallbackStorageObject(storageObj) {
        return {
            getItem(key) {
                return storageObj[key] || null;
            },
            setItem(key, value) {
                storageObj[key] = String(value);
            },
            removeItem(key) {
                delete storageObj[key];
            },
            clear() {
                storageObj = {};
            },
            getAllKeys() {
                return Odigeo._.keys(storageObj);
            },
        };
    }
}

module.exports = StorageClass;
